import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';
import YouTubeIcon from '@material-ui/icons/YouTube';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { Box } from '@material-ui/core';
import useStyles from './styles';

const SearchBar = props => {
  const {
    search,
    videos,
    onSearch,
    isAnalyzed,
    handleSearch,
    handleAnalyzeVideos,
  } = props;

  const classes = useStyles();
  const [searchedVideo, setSearchedVideo] = useState('')
  return (
    <Paper className={classes.root}>
      <Box className={classes.iconButton} aria-label='menu'>
        <YouTubeIcon />
      </Box>
      <InputBase
        value={search}
        onChange={event => {
          handleSearch(event)
          setSearchedVideo(event.target.value)
        }}
        className={classes.input}
        placeholder='Buscar Video'
        inputProps={{ 'aria-label': 'search youtube' }}
      />
      <IconButton
        onClick={() => onSearch()}
        className={classes.iconButton}
        aria-label='search'
        disabled={!searchedVideo}
      >
        <SearchIcon />
      </IconButton>
      <Divider className={classes.divider} orientation='vertical' />
      {!isAnalyzed?.loading ? (
        <IconButton
          disabled={!(videos.length > 0)}
          onClick={() => handleAnalyzeVideos()}
          className={classes.iconButton}
          aria-label='directions'
        >
          <AssessmentIcon />
        </IconButton>
      ) : (
        <CircularProgress />
      )}
    </Paper>
  );
};

export default SearchBar;
